import { useNavigate, useSearch } from "@tanstack/react-router"
import { IconPaperPlaneFill18 as SendIcon } from "nucleo-ui-fill-18"
import { useWindowSize } from "react-use"
import resolveConfig from "tailwindcss/resolveConfig"

import { Button, IconButton } from "@productlane/ui"

import type { NotifyRecipientEntity } from "./types"
import tailwindConfig from "../../../../tailwind.config"
import { SendUpdateModal } from "../send-update-modal"

interface NotifyRecipientsProps {
	entity: NotifyRecipientEntity
}

const fullConfig = resolveConfig(tailwindConfig)

const NOTIFY_PARAM = "notifyRecepients"

export const NotifyRecipients = ({ entity }: NotifyRecipientsProps) => {
	const navigate = useNavigate()
	const isOpen = Boolean(
		useSearch({ strict: false, select: (s) => s[NOTIFY_PARAM] }),
	)
	const { width } = useWindowSize()
	const md = fullConfig.theme.screens.md

	const handleOpenChange = (open: boolean) => {
		void navigate({
			to: ".",
			search: (prev) => ({
				...prev,
				[NOTIFY_PARAM]: open ? "true" : undefined,
			}),
			replace: true,
			resetScroll: false,
		})
	}

	return (
		<>
			{width >= parseInt(md) ? (
				<Button
					Icon={SendIcon}
					variant="outline"
					onClick={() => handleOpenChange(true)}
				>
					Send update
				</Button>
			) : (
				<IconButton
					Icon={SendIcon}
					variant="outline"
					onClick={() => handleOpenChange(true)}
				/>
			)}
			<SendUpdateModal
				isOpen={isOpen}
				onOpenChange={handleOpenChange}
				entity={entity}
			/>
		</>
	)
}
